function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.20028 -0.00059469C4.29914 -0.000790184 4.39691 0.0200838 4.48708 0.0606398C4.57724 0.101196 4.65773 0.160501 4.72318 0.234604L10.3232 6.53461C10.4371 6.66264 10.5 6.82804 10.5 6.99941C10.5 7.17077 10.4371 7.33617 10.3232 7.46421L4.72318 13.7642C4.66214 13.8329 4.58817 13.8888 4.5055 13.9289C4.42283 13.969 4.33308 13.9924 4.24136 13.9978C4.14964 14.0032 4.05776 13.9905 3.97096 13.9604C3.88416 13.9303 3.80414 13.8833 3.73548 13.8223C3.66681 13.7613 3.61083 13.6873 3.57075 13.6046C3.53067 13.522 3.50726 13.4322 3.50187 13.3405C3.49647 13.2488 3.50919 13.1569 3.53931 13.0701C3.56942 12.9833 3.61634 12.9033 3.67738 12.8346L8.86438 6.99941L3.67738 1.1642C3.58751 1.06346 3.52872 0.938852 3.50812 0.805429C3.48752 0.672006 3.50597 0.535473 3.56126 0.41231C3.61655 0.289148 3.70631 0.184621 3.8197 0.111351C3.9331 0.0380825 4.06527 -0.000796881 4.20028 -0.00059469Z",
  fill: "#5C5F62"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "white",
  transform: "translate(14 14) rotate(-180)"
})));

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.f266057f.svg";
export { ForwardRef as ReactComponent };